/**
 * @generated SignedSource<<ea54023c9362ea963934ba63698f970f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveExcludeDispatchConditionInput = {
  clientMutationId?: string | null;
  dispatchConditionId: string;
  messageDispatchId: string;
};
export type removeDispatchConditionButton_RemoveExcludeDispatchConditionMutation$variables = {
  input: RemoveExcludeDispatchConditionInput;
};
export type removeDispatchConditionButton_RemoveExcludeDispatchConditionMutation$data = {
  readonly Admin: {
    readonly Message: {
      readonly removeExcludeDispatchCondition: {
        readonly messageDispatch: {
          readonly id: string;
        };
      } | null;
    };
  };
};
export type removeDispatchConditionButton_RemoveExcludeDispatchConditionMutation = {
  response: removeDispatchConditionButton_RemoveExcludeDispatchConditionMutation$data;
  variables: removeDispatchConditionButton_RemoveExcludeDispatchConditionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Message",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "RemoveExcludeDispatchConditionPayload",
            "kind": "LinkedField",
            "name": "removeExcludeDispatchCondition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MessageDispatch",
                "kind": "LinkedField",
                "name": "messageDispatch",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "removeDispatchConditionButton_RemoveExcludeDispatchConditionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "removeDispatchConditionButton_RemoveExcludeDispatchConditionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "16619d08c3e6f3ecdc0d42f2c937f46e",
    "id": null,
    "metadata": {},
    "name": "removeDispatchConditionButton_RemoveExcludeDispatchConditionMutation",
    "operationKind": "mutation",
    "text": "mutation removeDispatchConditionButton_RemoveExcludeDispatchConditionMutation(\n  $input: RemoveExcludeDispatchConditionInput!\n) {\n  Admin {\n    Message {\n      removeExcludeDispatchCondition(input: $input) {\n        messageDispatch {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "45ba89bd435f55c2ab25bf32ca873572";

export default node;
